import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  loading: {
    alignItems: 'center',
    backgroundColor: theme.colors.form__background_primary,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    height: 400,
    justifyContent: 'center',
    maxWidth: 'unset',
    padding: theme.spacing(12),
    width: 1280
  },
  spinner: {
    width: 96,
    height: 96
  },
  spinnerText: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.4,
    color: theme.colorPalette.green_100
  },
  coveragesInfo: {
    width: 580,
    padding: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  icon: {
    marginBottom: theme.spacing(2),
    width: 40
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  contentLabel: {
    color: theme.colorPalette.green_80
  },
  changes: {
    margin: 0,
    paddingLeft: theme.spacing(6)
  },
  notification: {
    margin: 0,
    padding: theme.spacing(4)
  },
  button: {
    padding: theme.spacing(1.5, 4),
    fontSize: 14,
    fontWeight: 600
  },
  alignSelfStart: {
    width: 185
  },
  alignSelfEnd: {
    alignSelf: 'flex-end'
  },
  buttonGrid: {
    padding: theme.spacing(0),
    width: 'auto'
  },
  resubmitChangeRequestPromptCard: {
    padding: theme.spacing(4),
    background: theme.colorPalette.beige_50,
    boxShadow: 'none',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& div': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& strong': {
        fontSize: 16,
        fontWeight: 600,
        color: theme.colorPalette.green_80
      },
      '& p': {
        marginTop: 4
      }
    }
  },
  buttonContainer: {
    display: 'flex !important',
    flexDirection: 'row !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    width: '95% !important'
  }
});

export default makeStyles(styles);
